import { isNull } from 'lodash'

import {
  splitCategoryTree,
  getShippingTypeByAffiliation,
  normalizedProduct
} from './helpers'

export const sendToApp = args => {
  if (!window.ReactNativeWebView || !window.ReactNativeWebView.postMessage) {
    return
  }

  window.ReactNativeWebView.postMessage(
    JSON.stringify({ type: 'tracker', ...args })
  )

  window.ReactNativeWebView.postMessage(
    JSON.stringify({ type: 'track', data: { ...args } })
  )
}

const addToCart = ({ cart, product }) => {
  if (isNull(cart.value)) return
  const category = splitCategoryTree(product.category)

  sendToApp({
    event: 'add_to_cart',
    properties: {
      currency: 'BRL',
      items: [
        {
          item_id: product.item_id,
          item_name: product.item_name,
          discount: product.discount,
          item_brand: product.item_brand,
          quantity: product.quantity,
          item_category: category[0] || '',
          item_category2: category[1] || '',
          item_category3: category[2] || '',
          item_category4: category[3] || '',
          item_category5: category[4] || '',
          price: product.price,
          currency: 'BRL',
          affiliation: product.affiliation
        }
      ],
      value: parseFloat(cart.value),
      shipping_tier: cart.shipping_tier
    }
  })
}

const removeFromCart = ({ cart, product }) => {
  if (isNull(cart.value)) return

  const category = splitCategoryTree(product.category)

  sendToApp({
    event: 'remove_from_cart',
    properties: {
      currency: 'BRL',
      items: [
        {
          item_id: product.item_id,
          item_name: product.item_name,
          discount: product.discount,
          item_brand: product.item_brand,
          quantity: product.quantity,
          item_category: category[0] || '',
          item_category2: category[1] || '',
          item_category3: category[2] || '',
          item_category4: category[3] || '',
          item_category5: category[4] || '',
          price: product.price,
          currency: 'BRL',
          affiliation: product.affiliation
        }
      ],
      value: parseFloat(cart.value),
      shipping_tier: cart.shipping_tier
    }
  })
}

const freightCosts = cart => {
  sendToApp({
    event: 'shipping',
    properties: {
      currency: 'BRL',
      shipping: parseFloat(cart.freightCost)
    }
  })
}

const purchase = context => {
  sendToApp({
    event: 'purchase',
    properties: {
      currency: 'BRL',
      ...context
    }
  })
}

const firstSale = context => {
  sendToApp({
    event: 'first_sale',
    properties: {
      currency: 'BRL',
      ...context
    }
  })
}

const addToWishlist = product => {
  const category = splitCategoryTree(product.category)
  const price = product.price.to
    ? parseFloat(`${product.price.to.integers}.${product.price.to.decimals}`)
    : ''

  sendToApp({
    event: 'add_to_wishlist',
    properties: {
      currency: 'BRL',
      items: [
        {
          item_id: product.id,
          item_name: product.name,
          discount: product.discountPercentage,
          item_brand: product.brand,
          item_category: category[0] || '',
          item_category2: category[1] || '',
          item_category3: category[2] || '',
          item_category4: category[3] || '',
          item_category5: category[4] || '',
          price: price,
          currency: 'BRL'
        }
      ],
      value: price
    }
  })
}

const addPaymentInfo = paymentInfo => {
  sendToApp({
    event: 'add_payment_info',
    properties: {
      items: paymentInfo.items.map(item => {
        const category = splitCategoryTree(item.category)
        return {
          item_id: item.item_id,
          item_name: item.item_name,
          discount: item.discount,
          item_brand: item.item_brand,
          item_category: category[0] || '',
          item_category2: category[1] || '',
          item_category3: category[2] || '',
          item_category4: category[3] || '',
          item_category5: category[4] || '',
          price: item.price,
          currency: 'BRL',
          affiliation: item.affiliation
        }
      }),
      currency: 'BRL',
      value: paymentInfo.value,
      coupon: paymentInfo.coupon,
      shipping_tier: paymentInfo.shipping_tier,
      payment_type: paymentInfo.payment_type,
      payment_installments: paymentInfo.payment_installments
    }
  })
}

const addShippingInfo = shippingInfo => {
  sendToApp({
    event: 'add_shipping_info',
    properties: {
      items: shippingInfo.items.map(item => {
        const category = item.category.split('/')
        return {
          item_id: item.item_id,
          item_name: item.item_name,
          discount: item.discount,
          item_brand: item.item_brand,
          item_category: category[0] || '',
          item_category2: category[1] || '',
          item_category3: category[2] || '',
          item_category4: category[3] || '',
          item_category5: category[4] || '',
          price: item.price,
          currency: 'BRL',
          affiliation: item.affiliation
        }
      }),
      currency: shippingInfo.currency,
      value: shippingInfo.value,
      coupon: shippingInfo.coupon,
      shipping: shippingInfo.shipping,
      shipping_tier: getShippingTypeByAffiliation(shippingInfo.items)
    }
  })
}

const clickBanner = banner => {
  sendToApp({
    event: 'clickBanner',
    properties: {
      page_url: banner.url,
      category: banner.category,
      label: banner.label,
      action: banner.action
    }
  })
}

const viewItem = product => {
  const category = splitCategoryTree(product.category)

  sendToApp({
    event: 'view_item',
    properties: {
      currency: 'BRL',
      items: [
        {
          item_id: product.id,
          item_name: product.name,
          discount: product.discountPercentage,
          item_brand: product.brand,
          item_category: category[0] || '',
          item_category2: category[1] || '',
          item_category3: category[2] || '',
          item_category4: category[3] || '',
          item_category5: category[4] || '',
          price: parseFloat(
            `${product.price.to.integers}.${product.price.to.decimals}`
          ),
          currency: 'BRL'
        }
      ],
      hasBuybox: product.hasBuybox,
      unavailable: product.unavailable ? 'ecommerce' : null,
      value: parseFloat(
        `${product.price.to.integers}.${product.price.to.decimals}`
      )
    }
  })
}

const viewCart = cart => {
  sendToApp({
    event: 'view_cart',
    properties: {
      items: cart.items.map(item => {
        const categories = splitCategoryTree(item.category)
        return {
          item_id: item.item_id,
          item_list_name: item.item_list_name,
          item_name: item.item_name,
          item_brand: item.item_brand,
          currency: 'BRL',
          discount: item.discount,
          price: item.price,
          affiliation: item.affiliation,
          item_category: categories[0] || '',
          item_category2: categories[1] || '',
          item_category3: categories[2] || '',
          item_category4: categories[3] || '',
          item_category5: categories[4] || ''
        }
      }),
      value: cart.value,
      currency: 'BRL',
      shipping_tier: getShippingTypeByAffiliation(cart.items)
    }
  })
}

const viewItemList = itemsList => {
  sendToApp({
    event: 'view_item_list',
    properties: {
      items: itemsList.items.map(normalizedProduct)
    }
  })
}

const selectItem = selectedItem => {
  sendToApp({
    event: 'select_item',
    properties: {
      items: selectedItem.map(normalizedProduct)
    }
  })
}

const beginCheckout = cart => {
  sendToApp({
    event: 'begin_checkout',
    properties: {
      items: cart.items.map(item => {
        const categories = splitCategoryTree(item.category)
        return {
          item_id: item.item_id,
          item_name: item.item_name,
          item_brand: item.item_brand,
          currency: 'BRL',
          discount: item.discount,
          price: item.price,
          affiliation: item.affiliation,
          item_category: categories[0] || '',
          item_category2: categories[1] || '',
          item_category3: categories[2] || '',
          item_category4: categories[3] || '',
          item_category5: categories[4] || ''
        }
      }),
      value: cart.value,
      currency: 'BRL',
      coupon: cart.coupon,
      shipping_tier: getShippingTypeByAffiliation(cart.items)
    }
  })
}

const login = method => {
  sendToApp({
    event: 'login',
    properties: {
      method
    }
  })
}

const viewListing = () => {
  sendToApp({
    event: 'view_listing',
    properties: {}
  })
}

const viewContent = () => {
  sendToApp({
    event: 'view_content',
    properties: {}
  })
}

const signUp = method => {
  sendToApp({
    event: 'sign_up',
    properties: {
      method
    }
  })
}

export default {
  addToCart,
  freightCosts,
  purchase,
  firstSale,
  addToWishlist,
  clickBanner,
  viewItem,
  login,
  signUp,
  viewListing,
  viewContent,
  removeFromCart,
  addPaymentInfo,
  addShippingInfo,
  viewCart,
  beginCheckout,
  selectItem,
  viewItemList
}
